<template>
  <div class="influence">
    <div v-drag-scroll id="list" class="influence-content">
      <div class="influence-item" v-for="(item, index) in influenceData" :key="index">
        <!-- <img class="influence-img" :src=item.img alt="" /> -->
        <div @click="changeCheck(index)" :style="{
          color: item.isCheck ? '#18a7e9' : '#b2b2af',
          cursor: 'pointer',
        }">
          {{ item.name }}
        </div>
        <div class="timeline-item__node" :style="{ background: item.isCheck ? '#18a7e9' : '#b2b2af' }"
          @click="changeCheck(index)">
          <i style="color: #fff" class="el-icon-check" v-if="item.isCheck"></i>
        </div>
        <div class="timeline-item__tail"></div>
      </div>
    </div>
    <i class="el-icon-error icon-error" @click="close"></i>
  </div>
</template>

<script>
import dragScroll from "@/api/setting/directives.js";

export default {
  name: "influence",
  directives: { dragScroll },
  props: { message: { type: Object } },
  data() {
    return {
      influenceData: [
        {
          name: "2018影像",
          isCheck: false,
          func: "addWMTSLayer",
          layerId: "tdtYnImg100cm2000_2018",
          args: [
            "https://maps.ynmap.cn/arcgis/rest/services/TdtYn/tdtYnImg100cm2000_2018/MapServer/WMTS",
            "tdtYnImg100cm2000_2018",
            "tdtYnImg100cm2000_2018",
            "EPSG:4490",
            1.4078260157100582,
            21,
            "default",
            [-180.0, 90.0],
            [
              97.48001977801334, 21.07835143804548, 106.26069501042377,
              29.25097122788427,
            ],
            [
              1.4078260157100582, 0.7031250000000002, 0.3515625000000001,
              0.17578125000000006, 0.08789062500000003, 0.043945312500000014,
              0.021972656250000007, 0.010986328125000003, 0.005493164062500002,
              0.002746582031250001, 0.0013732910156250004, 6.866455078125002e-4,
              3.433227539062501e-4, 1.7166137695312505e-4, 8.583068847656253e-5,
              4.2915344238281264e-5, 2.1457672119140632e-5,
              1.0728836059570316e-5, 5.364418029785158e-6, 2.682209014892579e-6,
              1.3411045074462895e-6,
            ],
            [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20,
            ],
            null,
            1,
          ],
        },
        {
          name: "2019影像",
          isCheck: false,
          func: "addWMTSLayer",
          layerId: "tdtYnImg100cm2000_2019",
          args: [
            "https://maps.ynmap.cn/arcgis/rest/services/TdtYn/tdtYnImg100cm2000_2019/MapServer/WMTS",
            "tdtYnImg100cm2000_2019",
            "tdtYnImg100cm2000_2019",
            "EPSG:4490",
            1.4078260157100582,
            21,
            "default",
            [-180.0, 90.0],
            [
              97.48001977801334, 21.07835143804548, 106.26069501042377,
              29.25097122788427,
            ],
            [
              1.4078260157100582, 0.7031250000000002, 0.3515625000000001,
              0.17578125000000006, 0.08789062500000003, 0.043945312500000014,
              0.021972656250000007, 0.010986328125000003, 0.005493164062500002,
              0.002746582031250001, 0.0013732910156250004, 6.866455078125002e-4,
              3.433227539062501e-4, 1.7166137695312505e-4, 8.583068847656253e-5,
              4.2915344238281264e-5, 2.1457672119140632e-5,
              1.0728836059570316e-5, 5.364418029785158e-6, 2.682209014892579e-6,
              1.3411045074462895e-6,
            ],
            [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20,
            ],
            null,
            1,
          ],
        },
        {
          name: "2020影像",
          isCheck: false,
          func: "addWMTSLayer",
          layerId: "TdtYn_tdtYnImg100cm2000",
          args: [
            "https://maps.ynmap.cn/arcgis/rest/services/TdtYn/tdtYnImg100cm2000/MapServer/WMTS",
            "TdtYn_tdtYnImg100cm2000",
            "TdtYn_tdtYnImg100cm2000",
            "EPSG:4490",
            1.4078260157100582,
            21,
            "default",
            [-180.0, 90.0],
            [
              97.48001977801334, 21.07835143804548, 106.26069501042377,
              29.25097122788427,
            ],
            [
              1.4078260157100582, 0.7031250000000002, 0.3515625000000001,
              0.17578125000000006, 0.08789062500000003, 0.043945312500000014,
              0.021972656250000007, 0.010986328125000003, 0.005493164062500002,
              0.002746582031250001, 0.0013732910156250004, 6.866455078125002e-4,
              3.433227539062501e-4, 1.7166137695312505e-4, 8.583068847656253e-5,
              4.2915344238281264e-5, 2.1457672119140632e-5,
              1.0728836059570316e-5, 5.364418029785158e-6, 2.682209014892579e-6,
              1.3411045074462895e-6,
            ],
            [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20,
            ],
            null,
            1,
          ],
        },
        {
          name: "2021影像",
          isCheck: false,
        },
        {
          name: "2022影像",
          isCheck: false,
          func: "addWMTSLayer",
          layerId: "tdtYnImg100cm2000",
          args: [
            "https://maps.ynmap.cn/services/img/map/4490/WMTS",
            "tdtYnImg100cm2000",
            "tdtYnImg100cm2000",
            "EPSG:4490",
            1.4078260157100582,
            21,
            "default",
            [-180.0, 90.0],
            [
              97.48001977801334, 21.07835143804548, 106.26069501042377,
              29.25097122788427,
            ],
            [
              1.4078260157100582, 0.7031250000000002, 0.3515625000000001,
              0.17578125000000006, 0.08789062500000003, 0.043945312500000014,
              0.021972656250000007, 0.010986328125000003, 0.005493164062500002,
              0.002746582031250001, 0.0013732910156250004, 6.866455078125002e-4,
              3.433227539062501e-4, 1.7166137695312505e-4, 8.583068847656253e-5,
              4.2915344238281264e-5, 2.1457672119140632e-5,
              1.0728836059570316e-5, 5.364418029785158e-6, 2.682209014892579e-6,
              1.3411045074462895e-6,
            ],
            [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20,
            ],
            null,
            1,
          ],
        },
      ],
      mapView: systemConfig.mapApi,
    };
  },

  methods: {
    close() {
      this.$emit("closeInfluence", this.influenceData);
    },
    changeCheck(index) {
      this.influenceData.forEach((item, i) => {
        let that = this;
        if (i == index) {
          item.isCheck = !item.isCheck;
          if (item.isCheck && item.layerId) {
            let param = this.convert(item.args);
            let code = `this.mapView.${item.func}(${param})`;
            eval(code);
          }
          if (item.isCheck && !item.layerId) {
            this.message.warning("当前年份暂无影像数据");
          }
        } else {
          if (item.layerId) {
            this.mapView.removeLayer(item.layerId);
          }
          item.isCheck = false;
        }
      });
    },
    convert(args) {
      let param = args.map((item) => {
        switch (typeof item) {
          case "string":
            return `'${item}'`;
          case "object":
            return JSON.stringify(item);
          default:
            return `${item}`;
        }
      });
      return param;
    },
  },
};
</script>

<style scoped>
.influence {
  width: 100%;
  background: rgb(255 255 255);
  border: 1px solid #18a7e9;
  padding: 0 20px;
  border-radius: 5px;
  position: relative;
}

.influence-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  padding: 20px 0;
}

.influence-content:active {
  cursor: move;
}

.influence-item {
  color: #939393;
  width: 100%;
  text-align: center;
  position: relative;
}

.influence-item:nth-child(1)>.influence-img {
  margin-left: 0;
}

.influence-img {
  width: 190px;
  border: 1px solid #046eff;
  border-radius: 5px;
  margin-left: 20px;
  cursor: pointer;
}

influence-img:nth-child(1) {
  margin-left: 0 !important;
}

ul,
li {
  list-style-type: none;
  color: #ffffff;
}

.timeline-item__tail {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5px;
  background: #ebebeb;
}

.timeline-item__node {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  /* background: #2ae3ff; */
  /* background: #b2b2af; */
  position: absolute;
  left: 50%;
  bottom: -5px;
  cursor: pointer;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.timeline-item__node:hover {
  transform: scale(1.2);
}

.icon-error {
  position: absolute;
  right: -10px;
  top: -15px;
  font-size: 30px;
  cursor: pointer;
  color: #6a6e77;
}
</style>